const isvalidateAdddress = (address) => {
  try {
    if (!address.name) {
      return { valid: false, message: "Name in Address not found" };
    }
    if (!address.number) {
      return { valid: false, message: "Door No in Address not found" };
    }
    if (!address.street) {
      return { valid: false, message: "Street in Address not found" };
    }
    if (!address.city) {
      return { valid: false, message: "City in Address not found" };
    }
    if (!address.state) {
      return { valid: false, message: "State in Address not found" };
    }
    if (!address.country) {
      return { valid: false, message: "Country in Address not found" };
    }
    if (!address.pincode) {
      return { valid: false, message: "Zipcode in Address not found" };
    }
    if (!address.phoneNumber) {
      return { valid: false, message: "Phone Number in Address not found" };
    }
    //  is valid
    return { valid: true, message: "" };
  } catch (error) {
    //  is invalid
    return { valid: false, message: "" };
  }
};

export default isvalidateAdddress;
